
import { defineComponent, inject, onUnmounted, ref } from 'vue'

export default defineComponent({
  name: 'ConfirmDialog',
  props: {
    showEventName: {
      type: String,
      required: true
    }
  },
  emits: ['onYes', 'onNo'],
  setup(props, { emit }) {
    const emitter: any = inject('emitter')
    const visible = ref(false)

    emitter.on(props.showEventName, show)
    emitter.on('hideDialogs', hide)

    function show() {
      visible.value = true
    }

    const hideDialog = () => {
      hide()
    }

    function hide() {
      visible.value = false
    }

    const onNoClick = () => {
      emit('onNo')
      hide()
    }

    const onYesClick = () => {
      emit('onYes')
      hide()
    }

    const onOverlayClick = () => {
      hide()
    }

    onUnmounted(() => {
      emitter.off(props.showEventName, show)
      emitter.off('hideDialogs', hide)
    })

    return {
      visible,
      onNoClick,
      onYesClick,
      hideDialog,
      onOverlayClick
    }
  }
})
